import { useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Input } from '../ui/input';
import { adminApi, apiError } from '../../lib/adminApi';

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminApi.post('/auth/change-password', { current_password: current, new_password: next });
      toast.success('Password updated');
      setCurrent(''); setNext('');
      onOpenChange(false);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Change password</DialogTitle>
          <DialogDescription>Use at least 10 characters.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input type="password" placeholder="Current password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="current-password-input" />
          <Input type="password" placeholder="New password" autoComplete="new-password" minLength={10} value={next} onChange={(e) => setNext(e.target.value)} required data-testid="new-password-input" />
          <button disabled={busy} className="w-full rounded-full bg-[#14366C] py-2.5 text-sm font-bold uppercase tracking-wider text-white disabled:opacity-60" data-testid="change-password-submit">Update password</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
